import type { AppAction } from '../actions';
import type { LocatePreferences } from 'src/store/types/locates';

export interface LocatesState {
    locatePreferences: LocatePreferences | null;
}

const initialState: LocatesState = {
    locatePreferences: null,
};

export const locates = (state = initialState, action: AppAction): LocatesState => {
    switch (action.type) {
        case 'locates::setLocatePreferences':
            return {
                ...state,
                locatePreferences: action.locatePreferences,
            };
        case 'masq::access-token::set': {
            return { ...initialState };
        }
    }
    return state;
};
